import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';



@Injectable({
  providedIn: 'root'
})
export class VideoService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetVideo():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Video/Get`);
  }

  DeleteVideo(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Video/Delete?id=${id}`);
  }

  CreateVideo(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Video/Create`,data);
  }
  UpdateVideo(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Video/Update`,data)
  }
}
